import { Box } from '@mui/material';
import { Children, type ReactNode } from 'react';

type SeparatorDotProps = {
    height?: number;
};

/** Thin vertical divider between inline meta-line segments. */
export function SeparatorDot({ height = 10 }: SeparatorDotProps) {
    return (
        <Box
            component="span"
            sx={{
                width: '1px',
                height,
                bgcolor: 'divider',
                flexShrink: 0,
            }}
        />
    );
}

type SeparatedProps = {
    children: ReactNode;
};

/** Renders its non-null children with a SeparatorDot strictly between them. */
export function Separated({ children }: SeparatedProps) {
    const items = Children.toArray(children);
    return (
        <>
            {items.flatMap((child, index) =>
                index > 0
                    ? [<SeparatorDot key={`sep-${index}`} />, child]
                    : [child]
            )}
        </>
    );
}
